import { FinalVisualizationBuilder } from '../../../../../../app/configurator/VisualizationBuilder';
import { WebShopProductListData } from '../../../../../../app/data/model';
import { ProductListTranslation } from '../../../../../../app/localization/SiteTranslation';
import { CurrencyFormatter } from '../../../../../../app/shared/common';
import { StoreUrl } from '../../../../../../app/shared/StoreUrl';
import { RelativeUrl } from '../../../../../../app/shared/Url';
import { ProductVariationProps } from './ProductVariationList/ProductVariation/ProductVariation';

export default class ProductThumbnailState {
  public readonly formattedLowestPrice: string;
  public readonly imageSrc: string;
  public readonly linkUrl: RelativeUrl;
  public readonly variations: ProductVariationProps[];

  public constructor(
    public readonly product: WebShopProductListData,
    public readonly translation: ProductListTranslation,
  ) {
    this.formattedLowestPrice = product.lowestPrice
      ? translation.fromPriceLabel.interpolate([['price', CurrencyFormatter.getFormattedPrice(product.lowestPrice)]])
      : '';
    this.imageSrc = FinalVisualizationBuilder.buildUrl(product.listingConfigurationCode);
    this.linkUrl = StoreUrl.webShopProductPageUrl(product.id, { code: product.listingConfigurationCode });
    this.variations = product.listingOptionVariations.map<ProductVariationProps>((variation) => ({
      id: variation.id,
      name: variation.name,
      thumbnail: variation.thumbnail,
    }));
  }
}
